<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "How long have you been sky diving? (Years)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0skyDiveHowLong`,
					props: {
						suggest: {
							typeIncludes: `skyDiveHowLong`
						},
						createOptions: {
							type: `skyDiveHowLong`,
							dataType: "number"
						}
					}
				},
				{
					label: "Are you a member of an organized club? ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isMemberOfSkyDiveClub`,
					props: {
						suggest: {
							typeIncludes: `isMemberOfSkyDiveClub`
						},
						createOptions: {
							type: `isMemberOfSkyDiveClub`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0memberOfSkyDiveClubDetails`,
					props: {
						suggest: {
							typeIncludes: `memberOfSkyDiveClubDetails`
						},
						createOptions: {
							type: `memberOfSkyDiveClubDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Are you a member of a military parachutist organization?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isMemberOfMilitaryParachuteOrg`,
					props: {
						suggest: {
							typeIncludes: `isMemberOfMilitaryParachuteOrg`
						},
						createOptions: {
							type: `isMemberOfMilitaryParachuteOrg`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0memberOfMilitaryParachuteOrgDetails`,
					props: {
						suggest: {
							typeIncludes: `memberOfMilitaryParachuteOrgDetails`
						},
						createOptions: {
							type: `memberOfMilitaryParachuteOrgDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Number of jumps in the last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfSkyDiveJumpsLast12Months`,
					props: {
						suggest: {
							typeIncludes: `numOfSkyDiveJumpsLast12Months`
						},
						createOptions: {
							type: `numOfSkyDiveJumpsLast12Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Number of jumps in the last 12 - 24 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfSkyDiveJumpsLast12to24Months`,
					props: {
						suggest: {
							typeIncludes: `numOfSkyDiveJumpsLast12to24Months`
						},
						createOptions: {
							type: `numOfSkyDiveJumpsLast12to24Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Jumps expected in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfSkyDiveJumpsNext12Months`,
					props: {
						suggest: {
							typeIncludes: `numOfSkyDiveJumpsNext12Months`
						},
						createOptions: {
							type: `numOfSkyDiveJumpsNext12Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Usual altitude of jumps",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0skyDiveJumpAltitude`,
					props: {
						suggest: {
							typeIncludes: `skyDiveJumpAltitude`
						},
						createOptions: {
							type: `skyDiveJumpAltitude`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Do you participate in sky diving exhibitions or competitions? ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isParticipateInSkyDiveExhibition`,
					props: {
						suggest: {
							typeIncludes: `isParticipateInSkyDiveExhibition`
						},
						createOptions: {
							type: `isParticipateInSkyDiveExhibition`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0participateInSkyDiveExhibitionDetails`,
					props: {
						suggest: {
							typeIncludes: `participateInSkyDiveExhibitionDetails`
						},
						createOptions: {
							type: `participateInSkyDiveExhibitionDetails`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Do you receive remuneration for your sky diving activity? ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isReceiveRemunerationForSkyDiving`,
					props: {
						suggest: {
							typeIncludes: `isReceiveRemunerationForSkyDiving`
						},
						createOptions: {
							type: `isReceiveRemunerationForSkyDiving`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0receiveRemunerationForSkyDivingDetails`,
					props: {
						suggest: {
							typeIncludes: `receiveRemunerationForSkyDivingDetails`
						},
						createOptions: {
							type: `receiveRemunerationForSkyDivingDetails`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
